import React from 'react';
import styles from './About.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ModuleWrap from "../ModuleWrap/ModuleWrap";

const About = (props) => {
    return (
        <ModuleWrap title="30 lat w branży" icon={props.icon}>
            <li><FontAwesomeIcon className={styles.iconChecked} icon={props.iconChecked}/>Profesjonalna obsługa</li>
            <li><FontAwesomeIcon className={styles.iconChecked} icon={props.iconChecked}/>Fachowe doradztwo</li>
            <li><FontAwesomeIcon className={styles.iconChecked} icon={props.iconChecked}/>Terminowość zleceń</li>
            <li><FontAwesomeIcon className={styles.iconChecked} icon={props.iconChecked}/>Atrakcyjny poziom cen</li>
            <li><FontAwesomeIcon className={styles.iconChecked} icon={props.iconChecked}/>Najwyższa jakość produkcji</li>
        </ModuleWrap>
    )
};

export default About;


// WEBPACK FOOTER //
// ./src/components/About/About.js